import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const MiscSettingsState = {
  miscSettings: {},
  miscSettingsLoading: false,
}

export const MiscSettingsActions = {
  createMiscSettings: async ({ commit }, value) => {
    commit('setMiscSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'misc',
        value,
      }).
      then(({ data }) => {
        commit('setMiscSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setMiscSettingsLoading', false))
  },

  getMiscSettings: async ({ commit }) => {
    commit('setMiscSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/misc').
      then(({ data }) => {
        commit('setMiscSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setMiscSettingsLoading', false))
  },

  updateMiscSettings: async ({ getters, commit }, value) => {
    commit('setMiscSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.miscSettingsId}`, {
        name: 'misc',
        value,
      }).
      then(({ data }) => {
        commit('setMiscSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setMiscSettingsLoading', false))
  },

  deleteMiscSettings: async ({ getters, commit }) => {
    commit('setMiscSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.miscSettingsId}`).
      then(({ data }) => {
        commit('setMiscSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setMiscSettingsLoading', false))
  },
}

export const MiscSettingsMutations = {
  setMiscSettings: (state, payload) => { state.miscSettings = payload },
  setMiscSettingsLoading: (state, payload) => { state.miscSettingsLoading = payload },
  setMiscSettingsValue: (state, payload) => { state.miscSettings.value = payload },
}

export const MiscSettingsGetters = {
  miscSettings: state => state.miscSettings,
  miscSettingsId: state => state.miscSettings?.id,
  miscSettingsLoading: state => state.miscSettingsLoading,
  miscSettingsValue: state => state.miscSettings?.value,
}
